import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyDROF2GpWOyxcucsUsxmJviWLKTQgzhD0g",
  authDomain: "state-sync-2d8a1.firebaseapp.com",
  projectId: "state-sync-2d8a1",
  storageBucket: "state-sync-2d8a1.firebasestorage.app",
  messagingSenderId: "259903727783",
  appId: "1:259903727783:web:1599e9883e2f628ad89382",
  measurementId: "G-PGRVVNR9KP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services with simple configuration
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

// Export Firebase services
export { db, auth, storage, analytics };